{
    "MaxPartitions": "Alleen de eerste {} partities worden gecontroleerd op apparaten. Schakel \"Telephony-Wide Reporting\" in de Telsys-instellingen in om alle partities te controleren.",
    "NAME": "ErrorLanguage",
    "Error_Title": "Sorry",
    "Error_SubTitle": "Wij kunnen de pagina die u zoekt niet vinden.",
    "Error_Message": "De pagina of bron is mogelijk verplaatst, bijgewerkt of verwijderd. \n \n Of u hebt het webadres verkeerd getypt. Controleer het adres en de spelling.",
    "Error_PageTitle": "Helaas kunnen wij de pagina die u zoekt niet vinden.",
    "Validations_MustBeUnique": "De waarde moet uniek zijn"
}